import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateFullName extends ValidateDefaults {
    constructor(obj) {
        obj = obj ? obj : {};
        super(obj);
        this.message = obj.message ? obj.message : 'Required';
        this.on = obj.on && Array.isArray(obj.on) ? obj.on : ['blur'];
    }

    validate(fullname) {
        if (!fullname) {
            return false;
        }
        let arr = fullname.split(' ');
        return arr.length > 1;
    }

    static defaultMessage() {
        return 'First and last name required';
    }
}
